<template>
  <b-form-group
    label="Bin No"
    label-for="title"
  >
    <validation-provider
      #default="{ errors }"
      name="Bin No"
      rules="required"
    >
      <b-form-input
        id="bin_no"
        v-model="dataItem.bin_no"
        placeholder="Bin No"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'BinNo',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['binsDefines/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
